import React from "react";
import { Box, Heading, Spinner } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { useResumeVersions } from "../hooks/useResumeDetails";
import ResumeVersionTimeline from "../components/ResumeVersionTimeline";

const ResumeVersionsPage = () => {
  const { id } = useParams();
  const { data, isLoading } = useResumeVersions(id);

  return (
    <Box p={6}>
      <Heading size="md" mb={4}>
        Resume Versions
      </Heading>
      {isLoading ? (
        <Spinner />
      ) : (
        <ResumeVersionTimeline versions={data?.data || []} />
      )}
    </Box>
  );
};

export default ResumeVersionsPage;
